import React, { Component } from 'react';
import MyPATExpansionStep from "../../../../common/MyPATExpansionStep";
import { StepStatus, StepProps } from "../../../../common/types/Stepper";
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import QuestionCard from '../../../components/QuestionCard';
import MyPATStepper from "../../../../../components/common/MyPATStepper";
import MyPATStep, { MyPATStepSubHeading, MyPATStepTitle } from "../../../../../components/common/MyPATStep";
import { Grid, WithStyles, Typography, withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';

import LinearProgress from '@material-ui/core/LinearProgress';
import QuestionComponent from './QuestionComponent/QuestionComponents';
import { contentRequestAccordianActions } from '../../../reducers/contentRequestAccordianState';
import SelectWithContent from '../SelectWithContent';
import { setQuestionData } from '../../../helper/setQuestionData';
import { setTestData } from '../../../helper/setTestData';
import TestComponent from '../CardDataTabs/TestComponent/TestComponent';
import { mockDataForQuestion } from './QuestionComponent/mockDataConstant';
import { questionCardStyle } from '../../../styles/questionCardStyle';
import { styles } from '../useStyles';
import MyPATTabs from "../../../../common/MyPATTabs";
import MyPATTab from "../../../../common/MyPATTab";
import { ContentEvaluation } from "../../../types/Constants";
import TrackRequestProcess from '../../CardData/CardDataTabs/TrackRequestProcess';

interface YourTaskProps extends WithStyles<typeof styles> {
    expansionRoot?: any,
    questionData: any,
    requestId: string,
    history: any,
    setAccordianState: Function,
    accordianState: any,
    accordianTouched: any,
    setAccordingTouchIndex: Function,
    setAccordianTouchWhileCreate: Function,
    accordianCreateTouched: any,
    handleChooseFromLibrary: Function,
    isComingFromQuestionComponent: boolean,
    isTabOpened: boolean,
    setIsTabOpened: Function,
    setProgressBarForQuestion: Function,
    setProgressBarForTest: Function,
    progressBar: any,
    contentRequestId: string,
    testDetails: any,
    totalCount: number,
    setTestAccordian: Function,
    accordianTest: any,
    type: any,
    contentRequestData: any
    setAccordianTouchIndex: any,
    classes: any,
    setIsBothTabOpen: Function,
    isBothTabOpen: boolean,
    setIsComingFromTest: Function,
    setFilterQuestionArray: Function,
    setType: Function,
    progressBarForQuestion: any,
    progressBarForTest: any,
    overallDone: any,
    setOverallStatus: Function,
    setActiveTabInParent: Function;
    totalUnresolvedCount: number;
    match: any;
}
interface YourTaskState {
    accordianTouchState: any,
    accordianCreateTouched: any,
    selectQuestionDialogOpen: boolean,
    isTestRequest: boolean,
    activeType: string,
}
const initialQuestionState = {
    linkId: '',
}
class YourTask extends Component<YourTaskProps, YourTaskState>{
    constructor(props: YourTaskProps) {
        super(props);
        this.state = {
            accordianTouchState: [...this.props.accordianTouched],
            accordianCreateTouched: { ...this.props.accordianCreateTouched },
            selectQuestionDialogOpen: false,
            isTestRequest: false,
            activeType: 'Question',
        }
    }

    setActiveTab(event: any) {
        this.props.setActiveTabInParent(event.target.id)
        this.setState({
            activeType: event.target.id
        }, () => {
            const { setType } = this.props;
            setTimeout(() => {
                setType({ type: this.state.activeType })
            }, 50);
        })
    }

    questionAndTestRequest = () => {
        const { classes, testDetails: { type = '' } = {}, totalCount = 0, type: formatType, requestId, accordianState, contentRequestData, progressBar, progressBarForQuestion, overallDone } = this.props;
        const { activeType } = this.state;
        const check = this.props.type;
        const len = this.props.questionData;
        // let ReqType = 'Publish'
        const testDisableFlag = progressBarForQuestion.totalCount === progressBarForQuestion.count ? true : false;
        return (
            <>
                <Typography
                    className={`${activeType === ContentEvaluation.contentEvaluation ? 'activeTab' : ''} subPanel `}
                    id={ContentEvaluation.contentEvaluation}
                    onClick={(e) => {
                        this.setActiveTab(e);
                    }}
                >
                    Content Creation
            </Typography>{" "}
                {/* className={classes.verticleLine} */}
                <Grid className={classes.verticleLine} ></Grid>
                <Typography
                    id={ContentEvaluation.testEvaluation}
                    className={`${activeType === ContentEvaluation.testEvaluation ? 'activeTab' : ''} subPanel `}
                    onClick={(e) => {
                        testDisableFlag ? this.setActiveTab(e) : false;
                    }}
                >
                    Test Compilation
                </Typography>
                {activeType === ContentEvaluation.contentEvaluation && (
                    <>
                        <QuestionComponent
                            type={formatType}
                            requestId={requestId}
                            accordianState={accordianState}
                            isTestRequest={false}
                            contentRequestData={contentRequestData}
                            overallDone={overallDone}
                            totalUnresolvedCount={this.props.totalUnresolvedCount}
                            match={this.props.match}
                        />
                    </>
                )}
                {activeType === ContentEvaluation.testEvaluation && (
                    <>
                        <TestComponent type={type} totalCount={totalCount}
                            testDetails={this.props.testDetails} isTestRequest={true}
                            contentRequestData={contentRequestData} requestId={requestId}
                            overallDone={overallDone}
                            match={this.props.match} 
                            isExtraTests={false}
                            />
                    </>
                )}

            </>
        )
    }


    componentWillMount = () => {
        const { setAccordingTouchIndex, questionData, isTabOpened } = this.props;

        if (!isTabOpened) {
            const { setAccordingTouchIndex, questionData = [] } = this.props;
            let accordianArray: any = []
            let index = 0;
            questionData && questionData.forEach((val: any) => {
                const { questions = [] } = val;
                questions.forEach(() => {
                    const quesArray = {
                        accordianIndex: index,
                        questionContent: []
                    }
                    accordianArray.push(quesArray);
                    index = index + 1;
                })
            })
            setAccordingTouchIndex(accordianArray);
        }
    }

    componentDidMount = () => {
        const { testDetails: { type = '', assignor = {} } = {}, totalCount = 0, type: formatType, requestId, accordianState, contentRequestData, progressBar } = this.props;
        let check = this.props.type;
        let filterArray: any = [];
        this.props.questionData.forEach((val: any) => {
            const { questions = [] } = val;
            questions.forEach((val: any) => {
                filterArray.push(val);
            })
        })
        const len = filterArray;
        if (len.length && check === 'test' && Object.keys(assignor).length !== 0) {
            check = 'both';
        }
        if (check !== 'both') {
            this.props.setActiveTabInParent(check);
        }

        setTimeout(() => {
            const { questionData = [], totalCount = 0, setIsBothTabOpen, setOverallStatus } = this.props;
            if (check === "both") {
                setQuestionData(this.props, check);
                setTestData(this.props, totalCount, check);
                // this.setState({ isTestRequest: false }, () => {
                //     setIsBothTabOpen({ booleanValue: true })
                //     this.props.setType({ type: this.state.activeType })
                // })
                setIsBothTabOpen({ booleanValue: true })
                this.props.setType({ type: this.state.activeType })

            } else if (filterArray && filterArray.length) {
                setQuestionData(this.props, check);
                this.setState({ isTestRequest: false });
            } else {
                setTestData(this.props, totalCount, check);
                this.setState({ isTestRequest: true })
            }
            let previousOverallDone = localStorage.getItem('overallData')
            console.log(this.props.overallDone);
            setOverallStatus({ booleanValue: previousOverallDone ? (previousOverallDone === 'true' ? true : false) : this.props.overallDone })
        }, 500);

    }
    componentDidUpdate = (prevProps: YourTaskProps) => {
        if (this.props.overallDone !== prevProps.overallDone) {
            let previousOverallDone = localStorage.getItem('overallData')
            this.props.setOverallStatus({ booleanValue: previousOverallDone ? (previousOverallDone === 'true' ? true : false) : this.props.overallDone })
        }
    }

    renderComponents = () => {
        const { testDetails: { type = '', assignor = {} } = {}, totalCount = 0, type: formatType, requestId, accordianState, contentRequestData, progressBar, overallDone } = this.props;
        let check = this.props.type;
        let filterArray: any = [];
        this.props.questionData.forEach((val: any) => {
            const { questions = [] } = val;
            questions.forEach((val: any) => {
                filterArray.push(val);
            })
        })
        const len = filterArray;

        if (len.length && check === 'test' && Object.keys(assignor).length !== 0) {
            check = 'both';
        }

        return (
            <>
                {check === 'question' &&
                    <QuestionComponent type={formatType} requestId={requestId} accordianState={accordianState} isTestRequest={this.state.isTestRequest} contentRequestData={contentRequestData} overallDone={overallDone} totalUnresolvedCount={this.props.totalUnresolvedCount} match={this.props.match} />}
                {check === 'test' && (len.length ? <QuestionComponent type={formatType} requestId={requestId} accordianState={accordianState} contentRequestData={contentRequestData} overallDone={overallDone} totalUnresolvedCount={this.props.totalUnresolvedCount} match={this.props.match} /> :
                    <TestComponent isExtraTests={false} type={type} totalCount={totalCount} testDetails={this.props.testDetails} isTestRequest={this.state.isTestRequest} contentRequestData={contentRequestData} requestId={requestId} overallDone={overallDone} match={this.props.match} />)
                }
                {check === 'both' && this.questionAndTestRequest()}
            </>
        )
    }

    render = () => {
        return (
            this.renderComponents()
        )
    }
}
const mapStateToProps = (state: any) => ({
    accordianState: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianState', []),
    accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
    accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
    isComingFromQuestionComponent: _.get(state, 'contentRequestData.contentRequestAccordianData.isComingFromQuestionComponent'),
    isComingFromTest: _.get(state, 'contentRequestData.contentRequestAccordianData.isBothTabOpen', false),
    isTabOpened: _.get(state, 'contentRequestData.contentRequestAccordianData.isTabOpened'),
    progressBarForQuestion: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForQuestion', {}),
    progressBarForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForTest', {}),
    accordianTest: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTest', []),
    contentRequestData: _.get(state, 'contentRequestData.contentRequestData'),
    isBothTabOpen: _.get(state, 'contentRequestData.contentRequestAccordianData.isBothTabOpen'),
    filteredQuestionArray: _.get(state, 'contentRequestData.contentRequestAccordianData.filteredQuestionArray', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setAccordianState: contentRequestAccordianActions.setAccordianState,
    setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
    setAccordianTouchWhileCreate: contentRequestAccordianActions.setAccordianTouchWhileCreate,
    setIsTabOpened: contentRequestAccordianActions.setIsTabOpened,
    setProgressBarForQuestion: contentRequestAccordianActions.setProgressBarForQuestion,
    setProgressBarForTest: contentRequestAccordianActions.setProgressBarForTest,
    setTestAccordian: contentRequestAccordianActions.setTestAccordian,
    setIsBothTabOpen: contentRequestAccordianActions.setIsBothTabOpen,
    setIsComingFromTest: contentRequestAccordianActions.setIsComingFromTest,
    setFilterQuestionArray: contentRequestAccordianActions.setFilterQuestionArray,
    setType: contentRequestAccordianActions.setType,
    setOverallStatus: contentRequestAccordianActions.setOverallStatus
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(styles)(YourTask));

